import React from 'react';
import { Table, Tag } from 'antd';
import {
  COLUMN_EXTRA_LARGE,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { checkValue } from 'utils';
import { renderWithTooltip } from 'utils/table';
import { SelectTableFilter } from 'components/Filters/SelectTableFilter';
import { InputFilter } from 'components/Filters/InputFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { CheckboxFilter } from 'components/Filters/CheckboxFilter';
import { currencyList } from 'utils/handbooks/bankAccountsHandbooks';

function BankAccountsTable({
  items,
  banks,
  loading,
  current,
  pageSize,
  totalRows,
  filters = {},
  onRowClick,
  onChange,
  onFilter,
}) {
  const { bin_iin, iik, bank_name, currency } = filters;

  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'name_ru',
      key: 'name_ru',
      width: 220,
      render: (value) => renderWithTooltip(value),
      filterDropdown: () => (
        <SelectTableFilter
          value={bank_name}
          dataSourse={banks}
          placeholder="Банк"
          itemKey="name"
          itemValue="name"
          getSelectedItem={(bankName) => onFilter({ bank_name: bankName })}
        />
      ),
      filterIcon: () => <FilterIcon isActive={bank_name} />,
    },
    {
      title: 'Номер счёта',
      dataIndex: 'account',
      key: 'account',
      filterDropdown: () => (
        <InputFilter
          value={iik}
          placeholder="Поиск по счетам"
          onFilterChange={(iik) => onFilter({ iik })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={iik} />,
    },
    {
      title: 'Валюта',
      dataIndex: 'currency',
      key: 'currency',
      render: checkValue,
      filterDropdown: () => {
        return (
          <CheckboxFilter
            filter={currency}
            filters={currencyList}
            onFilterChange={(currency) => onFilter({ currency })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={currency} />,
    },
    {
      title: 'БИН/ИИН',
      dataIndex: 'bin_iin',
      key: 'bin_iin',
      render: checkValue,
      filterDropdown: () => (
        <InputFilter
          value={bin_iin}
          placeholder="Поиск по ИИН"
          onFilterChange={(bin_iin) => onFilter({ bin_iin })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={bin_iin} />,
    },
    {
      title: 'Код',
      dataIndex: 'code',
      key: 'code',
      render: checkValue,
    },
    {
      title: 'БИК',
      dataIndex: 'bik',
      key: 'bik',
    },
    {
      title: 'Статус',
      dataIndex: 'active',
      key: 'active',
      render: (active) => {
        const text = active ? 'Активный' : 'Не активный';
        const color = active ? 'green' : 'red';

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      width: COLUMN_EXTRA_LARGE,
      title: 'Клиент',
      dataIndex: 'client_name',
      key: 'client_name',
      render: (name) => renderWithTooltip(name, 60),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      tableLayout="fixed"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { BankAccountsTable };
